import { render } from "./WeddingViewFormType4.vue?vue&type=template&id=3842c2e2&lang=true"
import script from "./WeddingViewFormType4.vue?vue&type=script&lang=js"
export * from "./WeddingViewFormType4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__